module.exports = __webpack_public_path__ + "img/ctrl-rx-theta-stub-0.43adee05.svg";